import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { TodoistIcon, TodoistSearchResultIcon } from './icon';

export const todoistConfig: ThirdPartyConfig = {
	displayName: 'Todoist',
	id: 'todoist',
	resourceType: ProductResourceTypes3P.Todoist,
	icon: get3PLogo(TodoistIcon, 'Todoist', 'medium'),
	searchResultIcon: get3PLogo(TodoistSearchResultIcon, 'Todoist', 'large'),
	integrationAri: 'ari:cloud:platform::integration/todoist',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
